<template>
  <!-- 需要维保车辆 -->
  <div>
    <!-- 维保车辆统计 -->
    <div>
      <!-- 标题 --><!-- 刷新 -->
      <div style="display: flex; align-items: center">
        <kl-label
          :title="$t('maintenance.needMaitainceSta')"
          icon="icon-icon_top_aqjk"
          bold
          :fontSize="14"
          style="margin-bottom: 12px; flex: 1"
        />
        <div style="font-size: 14px; line-height: 14px">
          {{$t("maintenance.end")}}<span style="color: #2a7aff"> {{ nowDate }} </span>{{$t("maintenance.data")}}
          <el-button
            :loading="loadingRefresh"
            :size="size"
            type=""
            style="margin-left: 10px"
            @click="refresh"
            >{{$t("maintenance.refresh")}}</el-button
          >
        </div>
      </div>
      <!-- 内容 -->
      <div style="margin-top: 16px; padding: 0 10px">
        <el-row :gutter="20">
          <el-col :span="6" v-for="config in itemConfig" :key="config.title">
            <item 
              :title="config.title + '('+$t('maintenance.Vehicles')+')'"
              :value="itemValue(config.title)"
              :color="config.color"
              @clickValue="itemValue(config.title) == '0' || itemValue(config.title) == 0 ? null : clickDeal(config.title)"
              @clickText="quickLinks(config.title)"
              :isActiveValue="itemValue(config.title) == '0' || itemValue(config.title) == 0 ? false : true"
              :isActiveText="config.isActiveText"
            ></item>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 维保车辆列表 -->
    <div>
      <!-- 标题 -->
      <div style="display: flex; align-items: center; margin-top: 25px">
        <div>
          <kl-label
            :title="$t('maintenance.needMaitainceList')"
            icon="icon-icon_top_aqjk"
            bold
            :fontSize="14"
            style="margin-bottom: 12px; text-align: left"
          ></kl-label>
        </div>
        <div style="flex: 1; text-align: right">
          <el-input
            v-model="inputCarNo"
            :placeholder="$t('maintenance.pleaseEnterTheLicensePlateNumber')"
            size="small"
            style="width: 280px"
            clearable
          ></el-input>
          <!-- 查询 -->
          <el-button
            size="small"
            style="margin-left: 10px"
            @click="handleQuery"
            >{{ $t("public.query")}}</el-button
          >
        </div>
      </div>
      <!-- 列表表格 -->
      <div class="page_container" style="margin-top: 15px">
        <el-table v-loading="loading" :data="listData" border :size="size" style="width: 100%" :header-cell-style="tableHeaderCellStyle">
          <el-table-column
            :label="$t('maintenance.order')"
            align="center"
            width="65"
            type="index"
          ></el-table-column>
          <el-table-column align="center" :label="$t('maintenance.basicInfo')">
            <el-table-column
              :label="$t('vehicle.carNo')"
              align="center"
              prop="carNo"
              min-width="90"
            ></el-table-column>
            <el-table-column
              :label="$t('maintenance.seatsNum')"
              align="center"
              prop="seatsNum"
              min-width="65"
            ></el-table-column>
            <el-table-column
              :label="$t('maintenance.driverName')"
              align="center"
              prop="driverName"
              min-width="90"
            ></el-table-column>
            <el-table-column
              :label="$t('maintenance.driverMobile')"
              align="center"
              prop="driverMobile"
              min-width="110"
            ></el-table-column>
            <el-table-column
              :label="$t('maintenance.driverLicense')"
              align="center"
              prop="driverLicense"
              min-width="145"
            ></el-table-column>
            <el-table-column
              :label="$t('maintenance.driverLicenseSpan')"
              align="center"
              prop="driverLicenseSpan"
              min-width="90"
            ></el-table-column>
            <el-table-column
              :label="$t('maintenance.driverQualification')"
              align="center"
              prop="qualification"
              min-width="145"
            ></el-table-column>
            <el-table-column
              :label="$t('maintenance.qualificationSpan')"
              align="center"
              prop="qualificationSpan"
              min-width="110"
            ></el-table-column>
          </el-table-column>
          <el-table-column :label="$t('maintenance.NJ')" align="center" min-width="">
            <el-table-column
              :label="$t('maintenance.expirationDate')"
              align="center"
              prop="NextCheckTime"
              min-width="90"
            ></el-table-column>
          </el-table-column>
          <el-table-column :label="$t('maintenance.BX')" align="center" min-width="">
            <el-table-column
              :label="$t('maintenance.expirationDate')"
              align="center"
              prop="NextInsureTime"
              min-width="90"
            ></el-table-column>
          </el-table-column>
          <el-table-column :label="$t('maintenance.BY')" align="center" min-width="">
            <el-table-column
              :label="$t('maintenance.BYWay')"
              align="center"
              prop="maintain_type"
              min-width="90"
            >
              <template slot-scope="scope"><span style="color:red;cursor: pointer;" @click="BYclick(scope.row)">{{ getBYCell(scope.row,"3") }}</span></template>
            </el-table-column>
          </el-table-column>
          <!-- <el-table-column :label="$t('maintenance.NextCheckTime_YQ')" align="center">
            <el-table-column
              :label="$t('maintenance.NextCheckTime_Year')"
              align="center"
              prop="NextCheckTime_Year"
              min-width="90"
            ></el-table-column>
            <el-table-column
              :label="$t('maintenance.NextCheckTime_Quarter')"
              align="center"
              prop="NextCheckTime_Quarter"
              min-width="90"
            ></el-table-column>
          </el-table-column> -->
        </el-table>
      </div>

      <!-- 需要维保车辆列表分页 -->
      <kl-pagination  style="padding-top:6px"
        :currentPage="currentPage" 
        :pageSize="pageSize" 
        :total="total" 
        @current-change="currentChange"
        @size-change="sizeChange"
      ></kl-pagination>
      <!-- 过期或者到期车辆情况表弹窗 -->
      <div>
        <el-dialog
          class="dialog expirationDialog"
          :title="$t('maintenance.ExpiredSituation')"
          :visible.sync="dialogVisible"
          :close-on-click-modal="false"
          :width="dialogWidth"
        >
          <el-table :data="list" border :size="size" v-loading="expirationLoading">
            <el-table-column
              :label="$t('maintenance.carNo')"
              align="center"
              prop="carNo"
              min-width="110"
            ></el-table-column>
            <el-table-column
              :label="$t('maintenance.driverName')"
              align="center"
              prop="driver"
              min-width="90"
            ></el-table-column>
            <el-table-column
              :label="deals.dialogCell"
              align="center"
              min-width="120"
            >
              <template slot-scope="scope">
                <span style="color:red">{{ getBYCell(scope.row,dialogType) }}</span>
                
              </template>
            </el-table-column>
            <el-table-column
              v-if="deals.dialogCell == $t('maintenance.BYWay')"
              :label="$t('maintenance.lastMaintainTime')"
              align="center"
              prop="lastMaintainTime"
              min-width="110"
            ></el-table-column>
            <el-table-column
              v-if="deals.dialogCell == $t('maintenance.BYWay')"
              :label="$t('maintenance.lastMaintainMileage')"
              align="center"
              prop="lastMaintainMileage"
              min-width="110"
            ></el-table-column>
            <el-table-column
              v-if="deals.dialogCell == $t('maintenance.BYWay')"
              :label="$t('maintenance.currentMileage')"
              align="center"
              prop="currentMileage"
              min-width="110"
            ></el-table-column>
            <el-table-column
              v-if="deals.dialogCell == $t('maintenance.BYWay')"
              :label="$t('maintenance.BYOverMileage')"
              align="center"
              prop="BYOverMileage"
              min-width="110"
            ></el-table-column>
            <el-table-column
              v-if="deals.dialogCell == $t('maintenance.BYWay')"
              :label="$t('maintenance.BYOverCycle')"
              align="center"
              prop="BYOverCycle"
              min-width="110"
            ></el-table-column>
            <el-table-column
              :label="$t('maintenance.state')"
              align="center"
              prop="state"
              fixed="right"
              min-width="130"
            ><template><span style="color:red">{{$t("maintenance.pending")}}</span></template></el-table-column>
            <el-table-column
              :label="$t('maintenance.deal')"
              align="center"
              prop="deal"
              fixed="right"
              min-width="110"
            >
              <template slot-scope="scope">
                <el-link
                  :underline="false"
                  style="margin-right: 10px; color: #2a7aff"
                  @click="deal(scope.row)"
                  ><i
                    class="el-icon-edit"
                    style="height: 16px; width: 16px"
                  ></i>
                  {{$t('maintenance.deal')}}</el-link
                >
              </template>
            </el-table-column>
          </el-table>
          <kl-pagination 
            :currentPage="expirateCurrentPage" 
            :pageSize="10" 
            :total="expirationTotal" 
            @current-change="expirateCurrentChange"
            @size-change="expirateSizeChange"
          ></kl-pagination>
        </el-dialog>
      </div>
      <!-- 处理弹窗 -->
      <div>
        <el-dialog
          class="dialog"
          :title="deals.carNo+' '+$t('maintenance.handlingOpinions')"
          width="370px"
          :visible.sync="deals.dialogDeal"
          append-to-body
          :close-on-click-modal="false"
        >
          <el-form style="padding-top: 16px" > 
			<!--   <el-form-item :label="$t('maintenance.carNo') + '：'">
			     <el-input  v-model="deals.carNo" :disabled="true" size="small"></el-input>
			   </el-form-item> -->
            <el-form-item :label="$t('maintenance.processingStatus')" >
              <el-select v-model="deals.dealState" placeholder="">
                <el-option :label="$t('maintenance.processed')" value="1"></el-option>
                <el-option :label="$t('maintenance.notProcessed')" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('maintenance.handlingOpinions') + '：'">
              <el-input
                type="textarea"
                :rows="2"
                :placeholder="$t('maintenance.PleaseEnterYourContent')"
                v-model="deals.textarea"
              >
              </el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitSave">{{$t("public.save")}}</el-button>
          </span>
        </el-dialog>
      </div>
      <!-- 保养详情弹窗 -->
      <div>
        <el-dialog  class="dialog dialogBY" :title="$t('maintenance.BYInfo')" :visible.sync="dialogBY" width="480px" :close-on-click-modal="false">
      <div  style="text-align:left;">
        <el-form ref="form"  :label-position="LanguageId == 1 ? 'right' : 'top'">
          <el-form-item :label="$t('maintenance.currentBY')" label-position="left" label-width="130px" filterable >
            <el-select v-model="dialogBYInfo.selCarNo" :size="size" style="width:250px" disabled>
            </el-select>
          </el-form-item>
          <el-form-item >
            <el-checkbox :label="$t('maintenance.alertsByMileage')" v-model="checkedMilea" disabled style="font-weight: bold;"></el-checkbox>
          </el-form-item>
          <el-form-item :label="$t('maintenance.lastMilea')" label-position="right" label-width="220px">
            <el-input v-model="dialogBYInfo.lastMilea" :size="size"  :style="{width:LanguageId == 1 ? '150px' : '250px'}" disabled></el-input><span> {{$t("runState.km")}}</span>
          </el-form-item>
          <el-form-item :label="$t('maintenance.intervalMilea')" label-position="right" label-width="220px">
            <el-input v-model="dialogBYInfo.intervalMilea" :size="size"  :style="{width:LanguageId == 1 ? '150px' : '250px'}" disabled></el-input><span> {{$t("runState.km")}}</span>
          </el-form-item>
          <el-form-item :label="$t('maintenance.reminder')" label-position="right" label-width="220px">
            <el-input v-model="dialogBYInfo.reminderPeriodMilea" :size="size"  :style="{width:LanguageId == 1 ? '150px' : '250px'}" disabled></el-input><span> {{$t("runState.km")}}</span>
          </el-form-item>

          <el-form-item >
            <el-checkbox :label="$t('maintenance.periodicReminders')" v-model="checkedCycle" disabled style="font-weight: bold;"></el-checkbox>
          </el-form-item>
          <el-form-item :label="$t('maintenance.lastTime')" label-position="right" label-width="220px">
            <el-date-picker v-model="dialogBYInfo.lastTime" placeholder="" :size="size"  :style="{width:LanguageId == 1 ? '150px' : '250px'}" disabled></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('maintenance.intervalTime')" label-position="right" label-width="220px">
            <el-input v-model="dialogBYInfo.intervalTime" :size="size"  :style="{width:LanguageId == 1 ? '150px' : '250px'}" disabled></el-input><span> {{$t("time.month")}}</span>
          </el-form-item>
          <el-form-item :label="$t('maintenance.reminder')" label-position="right" label-width="220px">
            <el-input v-model="dialogBYInfo.reminderPeriodTime" :size="size"  :style="{width:LanguageId == 1 ? '150px' : '250px'}" disabled></el-input><span> {{$t("maintenance.day")}}</span>
          </el-form-item>

          <el-form-item >
            <el-checkbox :label="$t('maintenance.ByEngineRunTime')" v-model="checkedRun" disabled style="font-weight: bold;"></el-checkbox>
          </el-form-item>
          <el-form-item :label="$t('maintenance.lastRun')" label-position="right" label-width="220px">
            <el-input v-model="dialogBYInfo.lastRun" :size="size"  :style="{width:LanguageId == 1 ? '150px' : '250px'}" disabled></el-input><span> {{$t("time.hour")}}</span>
          </el-form-item>
          <el-form-item :label="$t('maintenance.intervalTime')" label-position="right" label-width="220px">
            <el-input v-model="dialogBYInfo.intervalRun" :size="size"  :style="{width:LanguageId == 1 ? '150px' : '250px'}" disabled></el-input><span> {{$t("time.hour")}}</span>
          </el-form-item>
          <el-form-item :label="$t('maintenance.reminder')" label-position="right" label-width="220px">
            <el-input v-model="dialogBYInfo.reminderPeriodRun" :size="size"  :style="{width:LanguageId == 1 ? '150px' : '250px'}" disabled></el-input><span> {{$t("maintenance.day")}}</span>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import item from "@/views/dashboard/item.vue";
import { mapState } from "vuex";
import language from '@/utils/getLanguageId'
export default {
  data() {
    return {
      dialogWidth:null,
      dialogBY:false,
      checkedCycle:false,
      checkedRun:false,
      checkedMilea:false,
      dialogBYInfo:{
        lastRun:"",
        lastTime:"",
        lastMilea:"",
        intervalRun:"",
        intervalTime:"",
        intervalMilea:"",
        reminderPeriodRun:"",
        reminderPeriodTime:"",
        reminderPeriodMilea:"",
        selCarNo:"",
      },
      expirationLoading:false,
      deals: {
        dialogDeal: false,
        dialogCell: "",
        dealState: "1",
        textarea: "",
        handlerTime: "",
        handdlerByFlag: "",
        VID:0,
		NextInsureTime:"",
		carNo:""
      },
      expirationTotal: 0,
      expirateCurrentPage:1,
      expirationSize:10,
      total: 0,
      currentPage:1,
      loading:false,
      dialogType: 0, // 1年检登记 2保险登记 3保养登记 4从业资格 5运营证年检 6运营证季检
      dialogVisible: false,
      expirationList: [],
      loadingRefresh: false,
      listData: [],
      inputCarNo: "",
      maintananceStatistics: {
        annualInspection: "0",
        insurance: "0",
        qualificationSpan: "0",
        maintain: "0",
        operationCertificate_year: "0",
        operationCertificate_quarter: "0",
      },
      itemConfig:[
        {
          title:this.$t("maintenance.NJ"),
          color:"#FF106E",
          isActiveText:true
        },
        {
          title:this.$t("maintenance.BX"),
          color:"#FF106E",
          isActiveText:true
        },
        {
          title:this.$t("maintenance.qualificationSpan"),
          color:"#FF106E",
          isActiveText:false
        },
        {
          title:this.$t("maintenance.BY"),
          color:"#FF106E",
          isActiveText:true
        },
        // {
        //   title:this.$t("maintenance.NextCheckTime_Year"),
        //   color:"#FF106E",
        //   isActiveText:true
        // },
        // {
        //   title:this.$t("maintenance.NextCheckTime_Quarter"),
        //   color:"#FF106E",
        //   isActiveText:true
        // },
      ],
      LanguageId:1,
    };
  },
  components: { item },
  props: {
    size: {
      type: String,
    },
  },
  computed: {
    list(){
      if(this.expirationList != null && this.expirationTotal > 0){
        return this.expirationList.slice((this.expirateCurrentPage - 1) * this.expirationSize,this.expirateCurrentPage * this.expirationSize)
      }
    },
    nowDate() {
      return this.moment(new Date()).format("YYYY-MM-DD");
    },
    ...mapState({
      operator: (state) => state.user.operator,
    }),
  },
  methods: {
    handleQuery(){
      this.currentPage = 1;
      this.getTableList();
    },
    itemValue(v){
      switch (v) {
        case this.$t("maintenance.NJ")://"年检登记":
          return this.maintananceStatistics.annualInspection;
          break;
        case this.$t("maintenance.BX")://"保险登记":
          return this.maintananceStatistics.insurance;
          break;
        case this.$t("maintenance.qualificationSpan")://"从业资格有效期":
          return this.maintananceStatistics.qualificationSpan;
          break;
        case this.$t("maintenance.BY")://"保养登记":
          return this.maintananceStatistics.maintain;
          break;
        case this.$t("maintenance.NextCheckTime_Year")://"运营证年检":
          return this.maintananceStatistics.operationCertificate_year;
          break;
        case this.$t("maintenance.NextCheckTime_Quarter")://"运营证季检":
          return this.maintananceStatistics.operationCertificate_quarter;
          break;
      }
    },
    currentChange(page){
      this.currentPage = page;
      this.getTableList();
    },
    sizeChange(page){
      this.pageSize = page;
      this.getTableList();
    },
    expirateCurrentChange(page){
      this.expirateCurrentPage = page;
    },
    expirateSizeChange(size) {
      this.expirationSize = size;
    },
    BYclick(row){
      // console.log(row);
      // if (row.maintain_type) {
      //   switch (true) {
      //     case row.maintain_type == 1:
      //       this.checkedMilea = true;
      //       break;
      //     case row.maintain_type == 2:
      //       this.checkedCycle = true;
      //       break;
      //     case row.maintain_type == 3:
      //       this.checkedRun = true;
      //       break;
      //     default:
      //       return "";
      //   }
      // }
      this.dialogBYInfo.selCarNo = row.carNo;
      this.dialogBY = true;
      // 车牌号查保养列表，得到保养弹窗信息
      this.$api.maintainInfo({
        vehicle: row.carNo,
        OperatorID: this.operator.OperatorId,
        // OperatorID: 1668,
        PageNo: 1,
        PageSize: 10,
      })
      .then((res)=>{
        if(res && res.code == 200){
          this.dialogBYInfo = {
            lastRun: res.data[0].lastHours,
            intervalRun: res.data[0].intervalHours,
            reminderPeriodRun: res.data[0].remindHours,
    
            lastTime: res.data[0].lastContainDate,
            intervalTime: res.data[0].intervalMonths,
            reminderPeriodTime: res.data[0].remindDays,
    
            lastMilea: res.data[0].lastMileage,
            intervalMilea: res.data[0].intervalMileage,
            reminderPeriodMilea: res.data[0].remindMileage,
            selCarNo: res.data[0].carNo,
          }
        }
      })
    },
    getTableList() {
      this.loading = true;
      this.$api
        .maintananceInfo({
          vehicle: this.inputCarNo,
          CompanyID: this.operator.CompanyId,
          // CompanyID: 5657,
          PageNo: this.currentPage,
          PageSize: this.pageSize,
          OperatorID: this.$store.getters.operator.OperatorId,
        })
        .then((res) => {
          if (res.code == 200) {
            this.listData = res.data;
            this.total = res.count;
            this.loading = false;
          }
        })
        .catch((e)=>{
          this.loading = false;
        })
    },
    getBYCell(row,BYtype) {
      if (BYtype == "3") {
        if (row.maintain_type) {
          switch (true) {
            case row.maintain_type == 1:
              return this.$t("maintenance.LCTX");
            case row.maintain_type == 2:
              return this.$t("maintenance.ZQTX");
            case row.maintain_type == 3:
              return this.$t("maintenance.FDJTX");
            default:
              return "";
          }
        }
      } else if(BYtype == '2'){
        return row.NextInsureTime;
      }else if(BYtype == '1'){
        return row.nextCheckTime;
      }
    },
    getMtcStat() {
      this.$api
        .maintananceStatistics({
          CompanyID: this.operator.CompanyId,
          OperatorID: this.$store.getters.operator.OperatorId,
          // CompanyID: 5657,
        })
        .then((res) => {
          if (res.code == 200) {
            this.maintananceStatistics.annualInspection =
              res.data.annualInspection;
            this.maintananceStatistics.insurance = res.data.insurance;
            this.maintananceStatistics.maintain = res.data.maintain;
            this.maintananceStatistics.operationCertificate_quarter =
              res.data.operationCertificate_quarter;
            this.maintananceStatistics.operationCertificate_year =
              res.data.operationCertificate_year;
            this.maintananceStatistics.qualificationSpan =
              res.data.qualificationSpan;
          }
            this.loadingRefresh = false;
        })
        .catch((e)=>{
          this.loadingRefresh = false;
        })
    },
    getMtcStaDetail(type) {
      this.expirationLoading = true;
      this.$api
        .maintananceStaDetail({
          maintananceType: type,
          CompanyID: this.operator.CompanyId,
          // CompanyID: 5657,
          OperatorID: this.$store.getters.operator.OperatorId,
        })
        .then((res) => {
          if (res.code == 200) {
            this.expirationTotal = res.count;
            this.expirationList = res.data;
            this.expirationLoading = false;
          }
        })
        .catch((e)=>{
          this.expirationLoading = false;
        })
    },
    submitSave() {
      this.deals.dialogDeal = false;
      let handlerTime = undefined;
      if(this.dialogType == "2"){
        handlerTime = this.deals.NextInsureTime
      }else if(this.dialogType == "4"){
        handlerTime = this.nowDate;
      }else{
        handlerTime = this.deals.handlerTime
      }
      this.$api
        .maintananceDeal({
          vehicle: this.deals.VID,
          handdlerIndex: this.dialogType,
          handdlerByFlag:
            this.dialogType == "3" ? this.deals.handdlerByFlag : "",
          handlerTime: handlerTime,// this.dialogType == "2"?this.deals.NextInsureTime:this.deals.handlerTime,
          haddlerType: this.deals.dealState,
          haddlersuggestion: this.deals.textarea,
          DealPeople: this.operator.OpeName,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success(this.$t("public.hasSaved"));
            this.getMtcStaDetail(this.dialogType);
            this.getMtcStat();
            this.getTableList();
          }
        })
        .catch((e)=>{
          this.$message.error(this.$t("public.SaveFail"));
        })
    },
    deal(row) {
		console.log(row)
      this.deals.dialogDeal = true;
      this.deals.dealState = "1";
      this.deals.textarea = "";
      this.deals.VID = row.VID;
      this.deals.handlerTime = row.nextCheckTime;
      this.deals.handdlerByFlag = row.maintain_type;
	  this.deals.NextInsureTime=row.NextInsureTime;
	  this.deals.carNo=row.carNo;
    },
    clickDeal(val) {
      this.dialogVisible = true;
      //点击会有上一个点击的数据，会卡顿一下在刷新为新点击的数据，每次点击数据都清空
      this.expirationList = [];
      switch (val) {
        case this.$t("maintenance.NJ"):
          this.deals.dialogCell = this.$t("maintenance.NJ");//"年检登记";
          this.dialogType = "1";
          break;
        case this.$t("maintenance.BX"):
          this.deals.dialogCell = this.$t("maintenance.BX");//"保险登记";
          this.dialogType = "2";
          break;
        case this.$t("maintenance.qualificationSpan"):
          this.deals.dialogCell = this.$t("maintenance.qualificationSpan");//"从业资格有效期";
          this.dialogType = "4";
          break;
        case this.$t("maintenance.BY")://"保养登记":
          this.deals.dialogCell = this.$t("maintenance.BYWay");//"保养方式";
          this.dialogType = "3";
          break;
        case this.$t("maintenance.NextCheckTime_Year"):
          this.deals.dialogCell = this.$t("maintenance.NextCheckTime_Year");//"运营证年检";
          this.dialogType = "5";
          break;
        case this.$t("maintenance.NextCheckTime_Quarter"):
          this.deals.dialogCell = this.$t("maintenance.NextCheckTime_Quarter");//"运营证季检";
          this.dialogType = "6";
          break;
      }
      this.getMtcStaDetail(this.dialogType);
    },
    refresh() {
      this.loadingRefresh = true;
      this.nowDate = this.moment().format("YYYY-MM-DD");
	  this.getMtcStat();
      this.getTableList();
    },
    quickLinks (v){
      switch (v) {
        case this.$t("maintenance.NJ"):
          this.$router.push("/maintenance/annualInspection");
          break;
        case this.$t("maintenance.BX"):
          this.$router.push("/maintenance/insurance");
          break;
        case this.$t("maintenance.BY"):
          this.$router.push("/maintenance/upkeep");
          break;
        case this.$t("maintenance.NextCheckTime_Year"):
          this.$router.push("/maintenance/yearlyOrQuarter");
          break;
        case this.$t("maintenance.NextCheckTime_Quarter"):
          this.$router.push("/maintenance/yearlyOrQuarter");
          break;
      }
    },
    getWidth(){
      const body = document.body;
      const html = document.documentElement;
      const width = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
      switch(this.LanguageId){
        case 1:
          
          break;
        case 3:
          if(width <= 1348){
            this.dialogWidth = "700px"
          }else{
            this.dialogWidth = null;
          }
          break;
        default:
          if(width <= 1348){
            this.dialogWidth = "700px"
          }else{
            this.dialogWidth = null;
          }
          break;
      }
    },
    tableHeaderCellStyle () {
      return 'border-color: #D9E4F8;'
    }
  },
  mounted() {
    this.LanguageId = language(this.$store.getters.locale)
    this.getMtcStat();
    this.getTableList();
    window.addEventListener('resize',this.getWidth);
    this.getWidth();
  },
  destroyed(){
    window.removeEventListener('resize',this.getWidth);
  }
};
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px !important;
}
.dialog {
  ::v-deep .el-dialog__header {
    border-bottom: 1px solid #ebeef5 !important;
  }
}
.expirationDialog{
  ::v-deep .el-dialog__body{
    padding: 0px 0px 8px 0px !important;
  }
}
.dialogBY{
  ::v-deep .el-dialog__body{
    padding: 16px 20px !important;
  }
}
</style>